$(document).ready(function(){
    $(document).on({
        mouseenter: function() {
            $(this).prop('open', true);
        },
        mouseleave: function() {
            $(this).prop('open', false);
        },
        click: function(){
            var link = $(this).attr('link');
             window.location.href = link;
        }
    }, "header header-menu details");

    $(window).on('scroll', function() {
    var scrollTop = $(window).scrollTop();

    if (scrollTop >= 100) {
      $('.transparent_header').addClass('blur');
    } else {
      $('.transparent_header').removeClass('blur');
    }
  });
    
})